/**
 * Copyright (c) Stanislav Shishankin
 *
 * This source code is licensed under the MIT license.
 */

const {HtmlViewComponent} = require('./Html');
const {zzString, zzObj} = require('../index');

class Body extends HtmlViewComponent{
    setBody(view){
        this.body.value = view;
        
        return this;
    }
    
    setTitle(title){
        this.title.value = title;
        
        return this;
    }
    
    __initDOM(){
        this.__zzDOMChilds = [document.head, document.body];
    }

    constructor(options){
        super(null);

        options || (options = {});
        options.selector || (options.selector = {});
        options.selector.body || (options.selector.body = 'body');
        options.selector.title || (options.selector.title = 'title');
        options.body || (options.body = null);
        options.title || (options.title = '');
        
        this.title = new zzString(options.title);
        this.body = new zzObj(options.body);
        
        this.text( options.selector.title, this.title )
            .view( options.selector.body, this.body );

        this.__addEvents();
    }
};

module.exports = {Body};